import { cn } from '@/lib/utils';
import { OWNER_BADGE_TEXT_COLOR, ownerBadgeColor, ownerInitials } from './teamChats';

interface OwnerBadgeProps {
  ownerUserId: number | null;
  ownerUsername: string;
  className?: string;
}

/** A user's initials on their stable color. The initials always show, so color never stands alone. */
export function OwnerBadge({ ownerUserId, ownerUsername, className }: OwnerBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full px-1 text-[10px] font-semibold leading-none',
        className
      )}
      style={{ backgroundColor: ownerBadgeColor(ownerUserId), color: OWNER_BADGE_TEXT_COLOR }}
      title={ownerUsername}
      aria-label={ownerUsername}
      data-owner-badge={ownerUserId ?? 'deleted'}
    >
      {ownerInitials(ownerUsername)}
    </span>
  );
}
